import React from 'react';
import PropTypes from 'prop-types';
/* components */
import AuthWrapper from '../../components/auth-wrapper/auth-wrapper';

class RedirectPage extends React.PureComponent {
    componentDidMount() {
        if (this.props.model && this.props.model.returnUrl) {
            window.location.href = this.props.model.returnUrl;
        }
    }

    render() {
        return (
            <AuthWrapper heading="Redirection">
                <section className="sten-content__section">
                    <h2 className="text-center">You are now being returned to the application.</h2>
                </section>
                <section className="sten-content__section">
                    <p className="text-center">Once complete, you may close this tab</p>
                </section>
            </AuthWrapper>
        );
    }
}

RedirectPage.propTypes = {
    model: PropTypes.objectOf(PropTypes.any).isRequired
};

export default RedirectPage;
